import { render, staticRenderFns } from "./CustomerRideHistoryView.vue?vue&type=template&id=21841e4c&scoped=true&lang=pug&"
import script from "./CustomerRideHistoryView.vue?vue&type=script&lang=js&"
export * from "./CustomerRideHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRideHistoryView.vue?vue&type=style&index=0&id=21841e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21841e4c",
  null
  
)

export default component.exports